import { render, staticRenderFns } from "./8Step.vue?vue&type=template&id=1205b34e&scoped=true&"
import script from "./8Step.vue?vue&type=script&lang=js&"
export * from "./8Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1205b34e",
  null
  
)

export default component.exports